import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    '& > div': {
      margin: '0'
    },

    '& > div:not(:last-child)': {
      marginBottom: '24px'
    }
  }
}))

export default useStyles
